import React from "react";
import { Link } from "react-router-dom";

const SideBar = () => {
  return (
    <div className="border-r-2 border-gray-50">
      {/* --------------sidebar---------------- */}
      <div className="hidden md:block h-full py-20 px-4">
        <Link to="/profile">
          {" "}
          <button className="text-[#295700] border border-[#295700] px-4 py-1 rounded-sm block w-[120px] text-center mb-8">
            General
          </button>
        </Link>
        <Link to="/changepassword">
          {" "}
          <button className="bg-[#295700] text-white px-4 py-1 rounded-sm block w-[120px] text-center mb-6">
            Settings
          </button>
        </Link>
        <Link to="/signIn">
          <button className="text-[#295700] border border-[#295700] px-4 py-1 rounded-sm block w-[120px] text-center mb-8">
            Log Out
          </button>
        </Link>
      </div>
    </div>
  );
};

export default SideBar;
